//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import 'swiper/swiper-bundle.css';

export default {
  name: 'ProductPreview',
  components: {
    PreviewSmallVideo: () => import('@motionelements/catalog/src/modules/product/preview/PreviewSmallVideo.vue'),
    PreviewVr: () => import('@motionelements/catalog/src/modules/product/preview/PreviewVr.vue'),
    // PreviewAudio: () => import('@motionelements/catalog/src/modules/product/preview/PreviewAudio.vue'),
    PreviewAudio: () => import('@motionelements/product2025/src/components/preview/PreviewAudio.vue'),
    PreviewShadow: () => import('@motionelements/product2025/src/components/PreviewShadow.vue'),
    ThumbnailGallerySwiper: () => import('@motionelements/catalog/src/modules/product/preview/carousel/ThumbnailGallerySwiper.vue'),
    PreviewLarge: () => import('@motionelements/catalog/src/modules/product/preview/PreviewLarge.vue'),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      previewType: 'product/previewType',
      thumbnails: 'product/thumbnails',
      showThumbGallery: 'product/showThumbGallery',
      videoPreview: 'product/videoPreview',
      recommendedMusicElements: 'product/getRecommendedMusicElements',
    }),
    thumbSwiperOptions() {
      return {
        spaceBetween: 8,
        freeMode: true,
        sticky: true,
        slidesPerView: 2.5,
        breakpoints: {
          768: {
            slidesPerView: 4.5,
          },
          992: {
            slidesPerView: 6.5,
          },
          1200: {
            slidesPerView: 4.5,
          },
          1600: {
            slidesPerView: 6.5,
          },
        },
      };
    },
  },
};
